import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";

// Apply optional environment-driven festival heading font globally
try {
	const fontName = process.env.REACT_APP_FESTIVALAKI_HEADING_FONT;
	if (fontName) {
		document.documentElement.style.setProperty(
			"--ff-heading",
			fontName.includes(" ") ? `'${fontName}'` : fontName
		);
	}
} catch (e) {
	// ignore when running outside browser-like environment
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
